import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LegalsupportResponseService {

  constructor(private httpClient: HttpClient) { }

  TOKEN = 'Bearer ' + window.localStorage.getItem('token');


  billlegal_accept(company_id: any) {
    const userId = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/getoverbillduedetails_acceptmail/?company_id=` + company_id);
  }
}
